import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { usePlotContext } from '../context';
import { useRefreshAfterGraphRendered } from '../hooks';
import { Marker } from './Marker';
import { XYCanvas } from './XYCanvas';
export function EventsCanvas(_a) {
    var id = _a.id, events = _a.events, renderEventMarker = _a.renderEventMarker, mapEventToXYCoords = _a.mapEventToXYCoords;
    var plotCtx = usePlotContext();
    var renderToken = useRefreshAfterGraphRendered(id);
    var eventMarkers = useMemo(function () {
        var markers = [];
        if (!plotCtx.getPlotInstance() || events.length === 0) {
            return markers;
        }
        for (var i = 0; i < events.length; i++) {
            var frame = events[i];
            for (var j = 0; j < frame.length; j++) {
                var coords = mapEventToXYCoords(frame, j);
                if (!coords) {
                    continue;
                }
                markers.push(React.createElement(Marker, __assign({}, coords, { key: id + "-marker-" + i + "-" + j }), renderEventMarker(frame, j)));
            }
        }
        return React.createElement(React.Fragment, null, markers);
    }, [events, renderEventMarker, renderToken, plotCtx]);
    if (!plotCtx.getPlotInstance()) {
        return null;
    }
    return React.createElement(XYCanvas, null, eventMarkers);
}
//# sourceMappingURL=EventsCanvas.js.map